import React, { FunctionComponent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@blueprintjs/core';
import ModalDialog from 'shared/modal/dialog';
import {
  TargetDeliveryTemplateAccessFunctionMenuActionsType,
} from 'data/targetDeliveryTemplateAccessFunction/targetDeliveryTemplateAccessFunction.types';
import './action-menus.scss';

type Props = {
  name: string;
  hasPrivilegesToCreate: boolean;
  hasPrivilegeToDelete: boolean;
  deleteTitle: string,
  deleteMessage: string | JSX.Element[],
  onEdit: ()=> void;
  onDelete: ()=> void;
  onCopy?: ()=> void;
}

const ActionMenus: FunctionComponent<Props> = ({
  name,
  hasPrivilegesToCreate,
  hasPrivilegeToDelete,
  deleteTitle,
  deleteMessage,
  onEdit,
  onDelete,
  onCopy,
}: Props) => {
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const { t } = useTranslation();

  const handleOpenDeleteDialog = () => {
    setIsDeleteDialogOpen(true);
  };

  const handleCloseDeleteDialog = () => {
    setIsDeleteDialogOpen(false);
  };

  const handleDelete = () => {
    onDelete();
    setIsDeleteDialogOpen(false);
  };

  if (name == null) {
    return null;
  }

  return (
    <div data-testid="ActionMenus" className="action-menus-container">
      {hasPrivilegesToCreate && (
      <Button
        className="menu-button"
        data-testid={`${TargetDeliveryTemplateAccessFunctionMenuActionsType.Edit}-button`}
        text={t('collectionFunction.grid.edit')}
        onClick={onEdit}
      />
      )}
      {hasPrivilegeToDelete && (
      <Button
        className="menu-button"
        data-testid={`${TargetDeliveryTemplateAccessFunctionMenuActionsType.Delete}-button`}
        text={t('collectionFunction.grid.delete')}
        onClick={handleOpenDeleteDialog}
      />
      )}
      {hasPrivilegesToCreate && onCopy && (
      <Button
        className="menu-button"
        data-testid={`${TargetDeliveryTemplateAccessFunctionMenuActionsType.Edit}-button`}
        text={t('collectionFunction.grid.copy')}
        onClick={onCopy}
      />
      )}
      <ModalDialog
        width="500px"
        isOpen={isDeleteDialogOpen}
        title={deleteTitle}
        displayMessage={deleteMessage}
        actionText={t('collectionFunction.deletePopup.action')}
        onSubmit={handleDelete}
        onClose={handleCloseDeleteDialog}
      />
    </div>
  );
};

export default ActionMenus;
